import React, { memo } from 'react'

import { CrownFilled, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

// The crown is decorative by default: a sibling (SubscribersOnlyHover's focusable,
// aria-labeled trigger) already announces the paid requirement. That trigger is
// dropped below the `sm` breakpoint, so on mobile callers pass `label` and the
// badge announces the requirement itself via role="img" + aria-label.
function PaidFeatureBadge({ className = '', label = '' }) {
  const accessibilityProps = label
    ? { role: 'img', 'aria-label': label }
    : { 'aria-hidden': 'true' }

  return (
    <span className={`paid-feature-badge ${className}`.trim()} {...accessibilityProps}>
      <Icon
        svgComponent={CrownFilled}
        className="paid-feature-badge__icon"
        size={{ width: '12', height: '12' }}
        notSpaced
      />
    </span>
  )
}

PaidFeatureBadge.propTypes = {
  className: string,
  label: string,
}

export default memo(PaidFeatureBadge)
